import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import Preloader from './components/Preloader';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import Hero from './components/Hero';
import Operations from './components/Operations';
import Offerings from './components/Offerings';

import Differentiators from './components/Differentiators';
import Services from './components/Services';
import InvestmentSectors from './components/InvestmentSectors';
import InvestmentPackages from './components/InvestmentPackages';
import About from './components/About';
import Stats from './components/Stats';
import InvestmentCalculator from './components/InvestmentCalculator';
import Contact from './components/Contact';
import Footer from './components/Footer';

// New page components
import ServicesPage from './components/pages/ServicesPage';
import AboutPage from './components/pages/AboutPage';
import BlockchainPage from './components/pages/BlockchainPage';
import RealEstatePage from './components/pages/RealEstatePage';
import IndicesPage from './components/pages/IndicesPage';
import StocksPage from './components/pages/StocksPage';
import FlexiblePlansPage from './components/pages/FlexiblePlansPage';
import CompoundingPlansPage from './components/pages/CompoundingPlansPage';
import FAQPage from './components/pages/FAQPage';
import PrivacyPolicyPage from './components/pages/PrivacyPolicyPage';
import TermsOfServicePage from './components/pages/TermsOfServicePage';
// Service pages
import InvestmentManagementPage from './components/pages/InvestmentManagementPage';
import FinancialPlanningPage from './components/pages/FinancialPlanningPage';
import RetirementPlanningPage from './components/pages/RetirementPlanningPage';
// Sector pages
import LoansAndGrantsPage from './components/pages/LoansAndGrantsPage';
import OilAndGasPage from './components/pages/OilAndGasPage';
// Investment Packages
import InvestmentPackagesPage from './components/pages/InvestmentPackagesPage';

import './App.css';

function App() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (isLoaded) {
      AOS.init({
        duration: 1000,
        easing: 'ease-in-out',
        once: true,
        mirror: false,
        offset: 100
      });
      
      // Refresh AOS on route changes
      const handleRouteChange = () => {
        AOS.refresh();
      };
      
      // Listen for route changes
      window.addEventListener('popstate', handleRouteChange);
      
      return () => {
        window.removeEventListener('popstate', handleRouteChange);
      };
    }
  }, [isLoaded]);
  
  // Refresh AOS when component updates (route changes)
  useEffect(() => {
    if (isLoaded) {
      AOS.refresh();
    }
  }, [isLoaded]);

  const handleLoadComplete = () => {
    setIsLoaded(true);
  };

  return (
    <Router>
      {!isLoaded && <Preloader onLoadComplete={handleLoadComplete} />}
      <ScrollToTop />
      <div className={`App min-h-screen bg-white ${!isLoaded ? 'opacity-0' : 'opacity-100 transition-opacity duration-500'}`}>
        <Header />
        <Routes>
          {/* Home page */}
          <Route path="/" element={
            <main className="animate-fade-in">
              <Hero />
              <About />
              {/* <Operations /> */}
              <Services />
              <InvestmentSectors />
              <InvestmentPackages />
              <Offerings />
              <Differentiators />
              <Stats />
              {/* <InvestmentCalculator /> */}
            </main>
          } />
          
          {/* Main pages */}
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/investment-packages" element={<InvestmentPackagesPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQPage />} />
          
          {/* Services */}
          <Route path="/services/investment-management" element={<InvestmentManagementPage />} />
          <Route path="/services/financial-planning" element={<FinancialPlanningPage />} />
          <Route path="/services/retirement-planning" element={<RetirementPlanningPage />} />
          
          {/* Sectors */}
          <Route path="/sectors/blockchain" element={<BlockchainPage />} />
          <Route path="/sectors/gold" element={<BlockchainPage />} />
          <Route path="/sectors/cryptocurrency" element={<BlockchainPage />} />
          <Route path="/sectors/loans-and-grants" element={<LoansAndGrantsPage />} />
          <Route path="/sectors/oil-and-gas" element={<OilAndGasPage />} />
          <Route path="/sectors/real-estate" element={<RealEstatePage />} />
          <Route path="/sectors/indices" element={<IndicesPage />} />
          <Route path="/sectors/stocks" element={<StocksPage />} />
          
          {/* Plans */}
          <Route path="/plans/flexible" element={<FlexiblePlansPage />} />
          <Route path="/plans/compounding" element={<CompoundingPlansPage />} />
          
          {/* Legal Pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
